import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaEye,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BusinessPromoVideoInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Business Promo Video Creation in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Business</Subheading>}
        heading={
          <Heading>
            Business <span tw="text-primary-500">Promo Video</span> Creation in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver professional business promo video
            creation services in **Dubai**, crafting high-impact, cinematic
            videos that showcase your brand, products, or services. Our videos
            drive engagement, enhance visibility, and convert audiences for
            businesses across industries.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551817958-c5b51e7b4a33?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional video camera setup
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video production team at work
          "https://images.unsplash.com/photo-1578574577315-3fbeb0cecdc2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Modern business skyline in Dubai
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Promo Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier Business Promo Video Creation in Dubai"
        description="We produce videos that elevate your business and captivate audiences."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Compelling Storytelling",
            description:
              "Engaging narratives that highlight your brand’s value.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success with Dubai’s top businesses.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick turnaround for marketing campaigns.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Engagement",
            description: "Videos designed to attract and convert.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Tailored to your business goals and industry.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for websites, social media, and ads.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Business Promo Video Creation Process"
        description={
          <Description>
            We craft impactful promo videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your business objectives and audience.
              </li>
              <li>
                Concept: Develop scripts and storyboards for maximum impact.
              </li>
              <li>
                Filming: Use 4K cameras and professional crews for stunning
                visuals.
              </li>
              <li>
                Editing: Enhance with motion graphics, voiceovers, and music.
              </li>
              <li>
                Delivery: Provide polished videos ready for immediate use.
              </li>
              <li>
                Support: Offer revisions and campaign performance insights.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1504465039710-0f49c0a47eb7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1522152716425-ec958d91dbf2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
          "https://images.unsplash.com/photo-1581591524425-c7e0978865fc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video production planning meeting
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Business Promo Video Wins in Dubai"
        description="Our videos have driven business growth and engagement."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Product Launch",
            description: "Boosted sales with a compelling promo video.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Increased reach for a Dubai startup.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from promo video clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Promote Your Business?</Subheading>}
        heading="Business Promo Video Creation in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for professional business promo video
            creation services in Dubai. Get high-impact, cinematic videos that
            drive results—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1513759565286-20e9c5fad06b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai business district skyline
          "https://images.unsplash.com/photo-1528109966604-5a6a3a443625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional videographer with equipment
          "https://images.unsplash.com/photo-1569159316193-42ecbf194bad?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Corporate video interview setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
